<template>
  <div class="d-flex justify-center align-center grey lighten-2" style="height: 85vh">
    <v-container>
      <v-row>
        <v-col cols="8" offset="2" class="d-flex justify-center">
          <span v-bind:style="{ fontSize: text_size + 'px', textAlign: 'center'}" class="font-weight-black">Você não tem permissão para acessar este conteúdo!</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8" offset="2" class="d-flex justify-center">
          <v-icon color="red" :size="icon_size">mdi-close-octagon</v-icon>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line no-undef
export default {
  name: "ErroAcessoNegado",
  computed: {
    icon_size () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 250
        case 'sm': return 300
        case 'md': return 350
        case 'lg': return 300
        case 'xl': return 400
      }
    },
    text_size () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 25
        case 'sm': return 30
        case 'md': return 35
        case 'lg': return 45
        case 'xl': return 65
      }
    }
  }
};
</script>
